/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-06 11:39:10
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  collection: { value: string, label: string },
  onRemove: (collection: Object) => void
};

type ComposedProps = WithI18nProps & Props;

class ConditionCollectionItem extends Component<ComposedProps> {
  render() {
    const { i18n, collection } = this.props;

    return (
      <span className="Polaris-Tag BC-Custom__Tag">
        <span
          title={i18n.translate('AdminHTML.Common.Autocomplete.draggableList_SpanTitle')}
          className="Polaris-Tag__TagText">
          {collection.label}
        </span>
        <button
          type="button"
          aria-label={i18n.translate('AdminHTML.Common.Autocomplete.draggableList_ButtonAriaLabel')}
          className="Polaris-Tag__Button"
          onClick={this.handleRemove}>
          <span className="Polaris-Icon">
            <svg
              viewBox="0 0 20 20"
              className="Polaris-Icon__Svg"
              focusable="false"
              aria-hidden="true">
              <path
                d="M11.414 10l4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z"
                fillRule="evenodd"></path>
            </svg>
          </span>
        </button>
      </span>
    );
  }

  handleRemove = () => {
    const { collectionIndex, onRemove } = this.props;
    onRemove('conditions', collectionIndex);
  };
}

export default withI18n()(ConditionCollectionItem);
